// The completion date picked for a hike, between an <input type="date"> and the
// createCompletedHike mutation's ISO8601 `completedAt`.
//
// The day is sent as midnight UTC, as the iOS and Android date pickers send it, so a
// completion reads as the same day on every platform.

/** Today as an <input type="date"> value (the user's local day): the picker's default and its max. */
export function todayDateInputValue(now: Date = new Date()): string {
  const pad = (n: number): string => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/**
 * The `completedAt` for a picked day, or null when the value isn't a real day. A day after
 * `today` is clamped to today, as the hike page's Completed form does.
 */
export function completedAtFromDateInput(value: string, today: string = todayDateInputValue()): string | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!match) return null;
  const [, y, m, d] = match.map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  if (date.getUTCFullYear() !== y || date.getUTCMonth() !== m - 1 || date.getUTCDate() !== d) return null;
  const day = value.trim() > today ? today : value.trim();
  return `${day}T00:00:00Z`;
}
